import { api } from "../lib/api";
import { usePoll } from "../lib/usePoll";
import { peso, clock } from "../lib/format";
import { Stat } from "../components/ui/kit";

export default function AccountingApp() {
  const { data: d } = usePoll(() => api.get("/reports/accounting").then((r) => r.data), 4000);
  if (!d) return <div className="grid min-h-[calc(100vh-49px)] place-items-center bg-slate-100"><div className="h-8 w-8 animate-spin rounded-full border-2 border-blue-600 border-t-transparent" /></div>;
  return (
    <div className="min-h-[calc(100vh-49px)] bg-slate-100 text-slate-900">
      <div className="mx-auto max-w-[1400px] space-y-4 p-4">
        <h1 className="font-head text-2xl font-black">Accounting & Reconciliation</h1>
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
          <Stat testid="acc-gross" label="Gross Sales" value={peso(d.gross_sales)} accent="text-blue-700" />
          <Stat label="Collections" value={peso(d.collections)} accent="text-emerald-700" />
          <Stat label="Outstanding" value={peso(d.outstanding)} accent="text-rose-600" />
          <Stat label="Tips Pool" value={peso(d.tips_pool)} accent="text-amber-600" />
        </div>
        <div className="grid gap-4 lg:grid-cols-3">
          <Card title="Collections by Method">
            {Object.entries(d.by_method || {}).length === 0 ? <Empty /> : Object.entries(d.by_method).map(([k, v]) => (
              <Line key={k} l={k} v={peso(v)} />
            ))}
          </Card>
          <Card title="Deductions & Charges">
            <Line l="Discounts (Senior/PWD/Promo)" v={peso(d.discounts)} />
            <Line l="Service Charge collected" v={peso(d.service_charge)} />
            <Line l="Purchases cost (FIFO)" v={peso(d.purchases_cost)} />
          </Card>
          <Card title="Corporate Receivables">
            {(d.corporate_receivables || []).map((c) => (
              <div key={c.company} className="py-1">
                <div className="flex justify-between text-sm"><span className="font-semibold">{c.company}</span><span className="font-mono">{peso(c.used)}</span></div>
                <div className="mt-1 h-1.5 rounded-full bg-slate-100"><div className="h-full rounded-full bg-blue-600" style={{ width: `${Math.min(100, (c.used / c.limit) * 100)}%` }} /></div>
                <div className="text-xs text-slate-400">limit {peso(c.limit)}</div>
              </div>
            ))}
          </Card>
        </div>
        <div className="grid gap-4 lg:grid-cols-2">
          <Card title="Tip Pool Report">
            {(d.tips_detail || []).length === 0 ? <Empty text="No tips yet" /> : d.tips_detail.map((t) => (
              <Line key={t.id} l={`${clock(t.timestamp)} · ${t.waiter || "team"} · ${t.order_number}`} v={peso(t.amount)} />
            ))}
          </Card>
          <Card title="Recent Payments (transaction traceability)">
            <div className="max-h-80 overflow-auto font-mono text-xs">
              {(d.payments || []).length === 0 ? <Empty /> : d.payments.map((p) => (
                <div key={p.id} className="flex justify-between border-t border-slate-100 py-1.5 first:border-0">
                  <span>{clock(p.timestamp)} · {p.order_number} · {p.method}</span>
                  <span className="font-bold">{peso(p.amount)}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

function Card({ title, children }) {
  return <div className="rounded-2xl border border-slate-200 bg-white p-4"><h3 className="mb-3 font-head text-sm font-black uppercase tracking-wide text-slate-500">{title}</h3>{children}</div>;
}
function Line({ l, v }) { return <div className="flex justify-between border-t border-slate-100 py-1.5 text-sm first:border-0"><span className="text-slate-600">{l}</span><b className="font-mono">{v}</b></div>; }
function Empty({ text = "No data yet" }) { return <p className="py-4 text-center text-sm text-slate-400">{text}</p>; }
